import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import { getFollowUpOverdueCount } from "../services/leadService";
import { usePermissions } from "../hooks/usePermission";

const LeadFollowUpsContext = createContext({ overdueCount: 0, refreshOverdueCount: () => {} });

const POLL_INTERVAL_MS = 60000;

export function LeadFollowUpsProvider({ children }) {
  const { canViewLeads, canViewAssignedLeads } = usePermissions();
  const canView = canViewLeads || canViewAssignedLeads;
  const [overdueCount, setOverdueCount] = useState(0);

  const refreshOverdueCount = useCallback(async () => {
    if (!canView) {
      setOverdueCount(0);
      return;
    }
    const count = await getFollowUpOverdueCount();
    setOverdueCount(count);
  }, [canView]);

  useEffect(() => {
    if (!canView) {
      setOverdueCount(0);
      return undefined;
    }
    refreshOverdueCount();
    const interval = setInterval(refreshOverdueCount, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [canView, refreshOverdueCount]);

  return (
    <LeadFollowUpsContext.Provider value={{ overdueCount, refreshOverdueCount }}>
      {children}
    </LeadFollowUpsContext.Provider>
  );
}

export const useLeadFollowUps = () => useContext(LeadFollowUpsContext);

export default LeadFollowUpsContext;
